import { makeError } from './logging';

export const error = (x) => makeError(['@adp-wfn/mdf-core', ...x]);
export const prettyPrint = (value) => JSON.stringify(value, null, '\t');

export * from './arrays';
export * from './logging';
export * from './mapIndex';
